import { render, staticRenderFns } from "./DrugUpsertForm.vue?vue&type=template&id=147c6e22"
import script from "./DrugUpsertForm.vue?vue&type=script&lang=js"
export * from "./DrugUpsertForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports